module.exports = __webpack_public_path__ + "img/KH.ab6df651.webp";